/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-formatting-rotate-counterclockwise': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M1.25 17.5V10c0-.69.56-1.25 1.25-1.25H10c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25H2.5c-.69 0-1.25-.56-1.25-1.25zM2.5 10v7.5H10V10H2.5zm8.125-8.75l.881.881L9.894 3.75h3.231A4.38 4.38 0 0117.5 8.125v3.125h-1.25V8.125A3.129 3.129 0 0013.125 5H9.894l1.612 1.619-.881.881L7.5 4.375l3.125-3.125z"/>'
  }
})
